// extracted by mini-css-extract-plugin
export default {"hand":"Hand_hand__0twH8","tileSlot":"Hand_tileSlot__JJf8m","letterSelect":"Hand_letterSelect__Wx0OW","emptyHand":"Hand_emptyHand__JaGUV"};